import { render, staticRenderFns } from "./OmniPageTitle.vue?vue&type=template&id=5d74c4ef&scoped=true&"
import script from "./OmniPageTitle.vue?vue&type=script&lang=js&"
export * from "./OmniPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./OmniPageTitle.vue?vue&type=style&index=0&id=5d74c4ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d74c4ef",
  null
  
)

export default component.exports